const NBSP = '\u00A0';
const EN_DASH = '\u2013';

export const formatEuro = (value: number): string => {
  if (value >= 1_000_000) {
    const m = value / 1_000_000;
    const rounded = Math.round(m * 10) / 10;
    return `${rounded.toString().replace('.', ',')}${NBSP}M€`;
  }
  if (value >= 1_000) {
    return `${Math.round(value / 1_000)}${NBSP}k€`;
  }
  return `${value}${NBSP}€`;
};

export const formatEuroRange = (min: number, max: number): string =>
  `${formatEuro(min)} ${EN_DASH} ${formatEuro(max)}`;

const orderOfMagnitude = (value: number): 'M' | 'k' | 'unit' => {
  if (value >= 1_000_000) return 'M';
  if (value >= 1_000) return 'k';
  return 'unit';
};

const numberOnlyForMagnitude = (value: number, mag: 'M' | 'k' | 'unit'): string => {
  if (mag === 'M') {
    const m = value / 1_000_000;
    const rounded = Math.round(m * 10) / 10;
    return rounded.toString().replace('.', ',');
  }
  if (mag === 'k') {
    return Math.round(value / 1_000).toString();
  }
  return value.toString();
};

export const formatEuroRangeCompact = (min: number, max: number): string => {
  const magMin = orderOfMagnitude(min);
  const magMax = orderOfMagnitude(max);
  if (magMin !== magMax) return formatEuroRange(min, max);
  const unit = magMax === 'M' ? 'M€' : magMax === 'k' ? 'k€' : '€';
  const a = numberOnlyForMagnitude(min, magMax);
  const b = numberOnlyForMagnitude(max, magMax);
  return `${a}${NBSP}${EN_DASH}${NBSP}${b}${NBSP}${unit}`;
};

export const formatNumber = (n: number): string => n.toLocaleString('fr-FR');

export const formatPeriod = (start: string, end: string): string =>
  `${start}${EN_DASH}${end}`;
